import React, { useState, useEffect } from "react";
import { useGlobalContext } from "../../GlobalContext";
import mutasipotonganPDF from "./pdf/mutasipotongan";
import rekappotonganPDF from "./pdf/rekappotongan";

function MutasiPotonganPerPeriode() {
  const { bulan, api } = useGlobalContext();
  const Tahunaktif = new Date().getFullYear();
  const tahunterakhir = Array.from({ length: 3 }, (_, i) => Tahunaktif - i);

  const [selectedBulan, setSelectedBulan] = useState(0);
  const [selectedYear, setSelectedYear] = useState(tahunterakhir[0]);
  const [unitkerja, setUnitKerja] = useState([]);
  const [kodeUnitkerja, setKodeUnitkerja] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedModel, setSelectedModel] = useState("1");
  const [isExporting, setIsExporting] = useState(false);

  useEffect(() => {
    const fetchUnitKerja = async () => {
      try {
        const res = await api.get(`/api/unit`);
        setUnitKerja(res.data.data || []);
      } catch (err) {
        console.error("Gagal mengambil unit kerja:", err);
      }
    };
    fetchUnitKerja();
  }, []);

  const handleBulanChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (!isNaN(value) && value >= 0 && value < bulan.length) {
      setSelectedBulan(value);
    }
  };

  const handleTahunChange = (e) => {
    setSelectedYear(e.target.value);
  };

  const handleSubmit = async () => {
    const bulanNumber = (selectedBulan + 1).toString().padStart(2, "0");
    const periode = `${selectedYear}${bulanNumber}`;
    const namaBulan = bulan[selectedBulan] || "Tidak Diketahui";
    const tahun = selectedYear;

    if (!kodeUnitkerja && selectedModel === "1") {
      alert("Silakan pilih Unit Kerja.");
      return;
    }

    setLoading(true);
    try {
      let res;

      if (selectedModel === "1") {
        res = await api.get(`/api/potongan/detail/${periode}/${encodeURIComponent(kodeUnitkerja)}`);
      } else {
        res = await api.get(`/api/potongan/rekap/${periode}`);
      }

      const result = res.data;
      const data = result || [];

      if (!Array.isArray(data) || data.length === 0) {
        alert(`Data potongan tidak ditemukan untuk periode ${namaBulan} ${tahun}.`);
      } else {
        if (selectedModel === "1") {
          mutasipotonganPDF(data, periode, namaBulan, tahun, kodeUnitkerja);
        } else {
          rekappotonganPDF(periode, data);
        }
      }
    } catch (err) {
      console.error("Gagal fetch:", err);
      alert(`Terjadi kesalahan: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleExportExcel = async () => {
    const bulanNumber = (selectedBulan + 1).toString().padStart(2, "0");
    const periode = `${selectedYear}${bulanNumber}`;
    const namaBulan = bulan[selectedBulan] || "Tidak Diketahui";
    const tahun = selectedYear;

    if (!kodeUnitkerja && selectedModel === "1") {
      alert("Silakan pilih Unit Kerja.");
      return;
    }

    setIsExporting(true);
    try {
      const token = localStorage.getItem('token');
      let url = '';
      if (selectedModel === '1') {
        url = `/api/exsportexcell/potongan/detail/${periode}/${encodeURIComponent(kodeUnitkerja)}`;
      } else {
        url = `/api/exsportexcell/potongan/rekap/${periode}`;
      }

      const response = await api.get(url, {
        responseType: 'blob',
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      });

      const filename = selectedModel === '1'
        ? `Potongan_${kodeUnitkerja}_${namaBulan}_${tahun}.xlsx`
        : `Rekap_Potongan_${namaBulan}_${tahun}.xlsx`;
      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const a = document.createElement('a');
      const urlBlob = window.URL.createObjectURL(blob);
      a.href = urlBlob;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(urlBlob);
    } catch (err) {
      console.error('Export Excel error:', err);
      if (err && err.response) {
        const status = err.response.status;
        const data = err.response.data;
        const msg = data && (data.message || data.msg) ? (data.message || data.msg) : JSON.stringify(data);
        alert(`Gagal mengekspor Excel. (${status}) ${msg}`);
        if (status === 401) {
          localStorage.removeItem('pengguna');
          localStorage.removeItem('token');
          window.location.href = '/login';
        }
      } else {
        alert('Gagal mengekspor Excel. Periksa koneksi atau server.');
      }
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className="row">
        <div className="col-md-12">
          <div className="card card-info" style={{ width: "400px" }}>
            <div className="card-header bg-info text-white">
              <h5 className="card-title">Laporan Bulanan Potongan</h5>
            </div>
            <div className="card-body">
              <form className="form-horizontal">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Periode</label>
                  <div className="col-sm-5">
                    <select
                      className="form-control"
                      value={selectedBulan}
                      onChange={handleBulanChange}
                    >
                      {bulan.map((item, index) => (
                        <option key={index} value={index}>
                          {item.toUpperCase()}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-sm-4">
                    <select
                      className="form-control"
                      value={selectedYear}
                      onChange={handleTahunChange}
                    >
                      {tahunterakhir.map((year) => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Unit Kerja</label>
                  <div className="col-sm-9">
                    <select
                      className="form-control"
                      value={kodeUnitkerja}
                      onChange={(e) => setKodeUnitkerja(e.target.value)}
                      required
                    >
                      <option value="">-- pilih --</option>
                      {unitkerja.map((uk) => (
                        <option key={uk.kode} value={uk.kode}>
                          {uk.unitkerja}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Model</label>
                  <div className="col-sm-9">
                    <select
                      className="form-control"
                      value={selectedModel}
                      onChange={(e) => setSelectedModel(e.target.value)}
                    >
                      <option value="1">Per UK</option>
                      <option value="2">Rekap</option>
                    </select>
                  </div>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-sm btn-primary"
                onClick={handleSubmit}
                disabled={loading || isExporting}
              >
                {loading ? "Mengambil Data..." : "Cetak"}
              </button>
              <button
                type="button"
                className="btn btn-sm btn-success ml-2"
                onClick={handleExportExcel}
                disabled={loading || isExporting}
              >
                {isExporting ? 'Mengekspor...' : 'Export Excel'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MutasiPotonganPerPeriode;
